import { render, staticRenderFns } from "./addLeadStoryModal.vue?vue&type=template&id=1d7e5b87&scoped=true"
import script from "./addLeadStoryModal.vue?vue&type=script&lang=js"
export * from "./addLeadStoryModal.vue?vue&type=script&lang=js"
import style0 from "./addLeadStoryModal.vue?vue&type=style&index=0&id=1d7e5b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e5b87",
  null
  
)

export default component.exports